import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { ResponseError } from '@backstage/errors';
import { TechTalk, TechTalkApi, TechTalkInput, TechTalkPermissions } from './types';

export class TechTalkClient implements TechTalkApi {
  constructor(
    private readonly options: {
      discoveryApi: DiscoveryApi;
      fetchApi: FetchApi;
    },
  ) {}

  private async request<T>(path: string, init?: RequestInit): Promise<T> {
    const baseUrl = await this.options.discoveryApi.getBaseUrl('tech-talk');
    const response = await this.options.fetchApi.fetch(`${baseUrl}${path}`, {
      headers: { 'Content-Type': 'application/json' },
      ...init,
    });
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    if (response.status === 204) {
      return undefined as T;
    }
    return response.json() as Promise<T>;
  }

  async createTechTalk(input: TechTalkInput): Promise<TechTalk> {
    return this.request<TechTalk>('/tech-talks', {
      method: 'POST',
      body: JSON.stringify(input),
    });
  }

  async getTechTalk(id: string): Promise<TechTalk> {
    return this.request<TechTalk>(`/tech-talks/${encodeURIComponent(id)}`);
  }

  async updateTechTalk(id: string, input: TechTalkInput): Promise<TechTalk> {
    return this.request<TechTalk>(`/tech-talks/${encodeURIComponent(id)}`, {
      method: 'PUT',
      body: JSON.stringify(input),
    });
  }

  async deleteTechTalk(id: string): Promise<void> {
    await this.request<void>(`/tech-talks/${encodeURIComponent(id)}`, {
      method: 'DELETE',
    });
  }

  async getPermissions(): Promise<TechTalkPermissions> {
    return this.request<TechTalkPermissions>('/permissions');
  }
}
